import * as React from "react"

import { cn } from "../../lib/utils"

const Input = React.forwardRef(({ className, type, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(
        "flex h-11 w-full rounded-lg border-2 border-[#9EB4C0]/20 bg-[#0b1c38]/50 backdrop-blur-sm px-4 py-2 text-base text-white shadow-sm transition-all duration-300 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-[#9EB4C0]/50 focus-visible:outline-none focus-visible:border-[#00f4ff] focus-visible:ring-2 focus-visible:ring-[#00f4ff]/30 focus-visible:shadow-lg focus-visible:shadow-[#00f4ff]/20 hover:border-[#00f4ff]/40 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
